<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12 md:col-12">
      <div class="card card-w-title">
        <HeaderBar createButton="true" @new-event="newProductDialog = true" title="مجموعه ویژگی" />
        <Divider type="dashed" />
        <!-- Table Section Begin -->
        <DataTable v-if="!!collections.length && !loading.page" ref="dt" @page="changePaging($event)" :value="collections" dataKey="id" :paginator="true" :rows="pageSize" class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink  RowsPerPageDropdown" responsiveLayout="scroll">
          <Column field="title" header="عنوان" headerStyle="width:14%; min-width:10rem;">
            <template #body="slotProps">
              <span class="p-column-title">عنوان</span>
              {{ slotProps.data.title }}
            </template>
          </Column>
          <Column header="تصویر" headerStyle="width:14%; min-width:10rem;">
            <template #body="slotProps">
              <span class="p-column-title">تصویر</span>
              <img :src="'https://api.koome.net/' + slotProps.data.icon" class="shadow-2" width="50" />
            </template>
          </Column>
          <Column header="عملیات" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" v-tooltip.top="'ویرایش'" class="p-button-rounded p-button-success ml-2" @click="editCollection(slotProps.data)" />
              <Button icon="pi pi-trash" v-tooltip.top="'حذف'" class="p-button-rounded p-button-warning mt-2" @click="confirmDeleteCollection(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
        <div v-if="!collections.length && !loading.page" class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <Loading v-if="loading.page" />
        <!-- Table Section End -->
        <!-- Edit Dialog Section Begin -->
        <Dialog @hide="editPicture = null" v-model:visible="featureDialog" :style="{ width: '450px' }" header="ویرایش" :modal="true" class="p-fluid">
          <div v-if="selected.icon">
            <img :src="'https://api.koome.net/' + selected.icon" width="150" class="mt-0 mx-auto mb-5 block shadow-2" />
            <div class="text-center">
              <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mb-2" @click="selected.icon = null" />
            </div>
          </div>
          <div v-else>
            <div v-if="!editPicture" class="text-center">
              <label for="pictureUploaderId" class="w-full justify-content-center cursor-pointer">
                <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
              </label>
              <input id="pictureUploaderId" @change="onUpload($event, 'edit')" accept="image/png, image/jpeg" type="file" hidden />
            </div>
            <div class="text-center relative" @click="editPicture = null" v-else>
              <img role="presentation" :alt="editPicture.name" :src="imageConvertBlob(editPicture)" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="editPicture = null" />
              </div>
            </div>
          </div>
          <div class="field">
            <label for="name">عنوان</label>
            <InputText
              id="name"
              v-model.trim="selected.title"
              @blur="v$.selected.title.$touch"
              @input="v$.selected.title.$touch"
              required="true"
              autofocus
              :class="
                ({ 'p-invalid': submitted && !selected.title },
                {
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.selected.title.$error,
                })
              "
            />
            <small v-if="v$.selected.title.required.$invalid && v$.selected.title.$dirty" ref="password_error_message" class="text-red-500">
              {{ v$.selected.title.required.$message }}
            </small>
            <!-- <small class="p-invalid" v-if="submitted && !selected.title">Name is required.</small> -->
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
            <Button label="ویرایش" icon="pi pi-check" class="p-button-text" @click="updateCollection" />
          </template>
        </Dialog>
        <!-- Edit Dialog Section Ended -->
        <!-- Delete Dialog Section Begin -->
        <Dialog v-model:visible="deleteFeatureDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex flex-column align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
            <span v-if="selected" class="mt-3">آیا مطمئن هستید؟</span>
          </div>
          <template #footer>
            <div class="text-center">
              <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="deleteFeatureDialog = false" />
              <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removeCollection" />
            </div>
          </template>
        </Dialog>
        <!-- New Dialog Section Ended -->
        <Dialog v-model:visible="newProductDialog" :style="{ width: '600px' }" header="ایجاد مجموعه ویژگی" :modal="true" class="p-fluid">
          <div class="flex align-items-center justify-content-center flex-column">
            <div v-if="!picture">
              <label for="fileUploaderId" class="w-full justify-content-center cursor-pointer">
                <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
              </label>
              <input id="fileUploaderId" @change="onUpload($event, 'add')" accept="image/svg+xml" type="file" hidden />
            </div>
            <div class="text-center relative" v-else>
              <img role="presentation" :alt="picture.name" :src="imageConvertBlob(picture)" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="picture = null" />
              </div>
            </div>
          </div>
          <div class="field">
            <span>
              <label for="catTitle">عنوان:</label>
              <InputText
                id="catTitle"
                type="text"
                v-model="collection.title"
                @blur="v$.collection.title.$touch"
                @input="v$.collection.title.$touch"
                :class="{
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.collection.title.$error,
                }"
              />
              <small v-if="v$.collection.title.required.$invalid && v$.collection.title.$dirty" ref="password_error_message" class="text-red-500">
                {{ v$.collection.title.required.$message }}
              </small>
            </span>
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="newProductDialog = false" />
            <Button type="submit" :disabled="!picture || !collection.title" class="p-button-text" label="ایجاد" icon="pi pi-check" @click="createFeatureCollection" :loading="loading[create]" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "featureCollectionPage",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      collection: {
        title: "",
      },
      picture: null,
      svgUploaded: "",
      loading: {
        page: false,
        create: false,
        update: false,
        remove: false,
      },
      collections: [],
      selected: {},
      featureDialog: false,
      deleteFeatureDialog: false,
      submitted: false,
      editPicture: null,
      pageSize: 10,
      newProductDialog: false,
    };
  },
  methods: {
    //******* Api methods begin *******//
    async getListCollection(page = 1) {
      this.loading.page = true;
      const { status, data } = await this.axios({ method: "get", url: `FeatureCollection/GetAll?TitleQuery=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.pageSize = data.pageSize;
      this.collections = [...data.data];
      this.loading.page = false;
    },
    async createFeatureCollection() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("icon", this.picture);
      formData.append("title", this.collection.title);
      const { status, data } = await this.axios({ method: "post", url: "FeatureCollection/Create", data: formData, config });
      status == 200 || status == 201 ? this.getListCollection() : false;
      this.showToast(status);
      this.newProductDialog = false;
      this.collection.title = "";
      this.picture = null;
    },
    async removeCollection() {
      const { status, data } = await this.axios({ method: "delete", url: `FeatureCollection/Delete/${this.selected.id}` });
      status === 200 ? (this.selected = {}) : "";
      this.getListCollection();
      this.deleteFeatureDialog = false;
    },
    async updateCollection() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("NewIcon", !!this.editPicture ? this.editPicture : null);
      formData.append("title", this.selected.title);
      const { status, data } = await this.axios({ method: "put", url: `FeatureCollection/Update/${this.selected.id}`, data: formData, config });
      this.showToast(status);
      if (status == 200) {
        this.getListCollection();
        this.selected = {};
        this.editPicture = null;
      }
      this.hideDialog();
    },
    changePaging(e) {
      this.getListCollection(++e.page);
    },
    //******* Api methods end *******//
    onUpload(event, status) {
      this.editPicture = null;
      this.picture = null;
      if (event.target.files[0].type === "image/svg+xml") {
        this.editPicture = null;
        status == "add" ? (this.picture = event.target.files[0]) : (this.editPicture = event.target.files[0]);
      } else {
        this.$toast.add({ severity: "error", summary: "خطا", detail: "فرمت وارد شده باید svg باشد", life: 3000 });
      }
      // const file = new FormData();
      // this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
    },
    editCollection(selected) {
      this.selected = { ...selected };
      this.featureDialog = true;
    },
    confirmDeleteCollection(selected) {
      this.selected = selected;
      this.deleteFeatureDialog = true;
    },
    hideDialog() {
      this.featureDialog = false;
      this.submitted = false;
    },
    imageConvertBlob(picture) {
      return URL.createObjectURL(picture);
    },
  },
  validations() {
    return {
      selected: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
      collection: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
    };
  },
  mounted() {
    this.getListCollection();
  },
};
</script>

<style lang="scss">
.file-uploader {
  width: auto;
  margin: 0;
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-items: center;
  -align: bottom;
  text-averticallign: center;
  overflow: hidden;
  position: relative;
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;

  &:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 black;
    outline: 0 none;
    outline-offset: 0;
  }
}

.remove-picture {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    transition-delay: all 0.8s ease-in-out;
    visibility: hidden;
  }

  &:hover {
    i {
      visibility: visible;
    }
  }
}
</style>
